<template>
  <div class="setting">
    <Nav :subNav="'关于小宝'" :isShowBack="1"></Nav>
    <div class="about-wrap">
      <div class="about-logo"></div>
      <div class="about-name">节点小宝</div>
      <div class="about-version">
        {{ $store.state.version ? "v" + $store.state.version : "v2.3.1" }}
      </div>
      <div class="about-desc">远程随心连接</div>
      <div class="about-nav-wrap" v-if="!$store.getters.isAppstoreMode">
        <div
          class="about-nav about-www"
          @click="openNewUrl('https://jdxb.ionewu.com/')"
        >
          小宝官网
        </div>
        <div class="about-nav about-help" @click="jumpDesc">功能介绍</div>
        <div class="about-nav about-help" @click="jumpHelp">帮助中心</div>
      </div>
      <div class="agreement">
        <span @click="openUrl('https://www.ionewu.com/JdxbUProtocol.html')"
          >《用户服务协议》</span
        >
        <span
          @click="openUrl('https://www.ionewu.com/JdxbPrivacyProtocol.html')"
          >《隐私政策》</span
        >
        <span
          @click="openUrl('https://www.ionewu.com/JdxbProtocol.html')"
          v-if="false"
          >《会员服务协议》</span
        >
      </div>
      <div class="copyright">
        Copyright @2022 版权所有 深圳市玩物科技有限公司
      </div>
    </div>
    <IframeAlert :url="url" @close="closeUrl" v-if="url"></IframeAlert>
  </div>
</template>
<script>
import IframeAlert from "@/components/IframeAlert.vue";
import Nav from "@/components/Common/Nav.vue";

export default {
  name: "Setting",
  data: function () {
    return {
      isShowHelp: false,
      url: "",
    };
  },
  components: {
    IframeAlert,
    Nav,
  },
  methods: {
    jumpDesc: function () {
      let _that = this;
      _that.$router.push({ path: "/home/desc" });
    },
    jumpHelp: function () {
      let _that = this;
      _that.$router.push({ path: "/home/answer" });
    },
    goBack: function () {
      if (this.isShowHelp) {
        this.hideHelp();
      } else {
        this.$router.back(-1);
      }
    },
    showHelp: function () {
      this.isShowHelp = true;
    },
    hideHelp: function () {
      this.isShowHelp = false;
    },
    backClick: function () {
      let _that = this;
      _that.$router.push({ path: "/home/userinfo" });
    },
    openUrl: function (url) {
      let _that = this;
      _that.url = url;
    },
    openNewUrl: function (url) {
      let _that = this;
      _that.$common.bridge(_that.$store.state.client).openBrowser(url);
    },
    closeUrl: function () {
      let _that = this;
      _that.url = "";
    },
  },
};
</script>
<style lang="less" scoped>
.help-wrap {
  width: 939px;
  height: 491px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 5px;
  background-color: #ffffff;
  // background-image: url(../assets/setting/bg.png);
  background-size: 100% 100%;
  border-radius: 5px;
  box-shadow: 0px 0px 2px 0px rgba(228, 224, 201, 1);
  .help-title {
    font-size: 27px;
    color: #2f4386;
    font-weight: bold;
    line-height: 32px;
    text-shadow: 0px 3px 3px rgba(40, 67, 142, 0.12);
    margin-top: 45px;
    text-align: center;
  }
  .help-middle-wrap {
    text-align: center;
    margin-top: 25px;
    .help-left-wrap {
      width: 310px;
      display: inline-block;
      vertical-align: top;
      .left-01 {
        width: 308px;
        height: 101px;
        overflow: hidden;
        background-color: #4e9eee;
        background-image: linear-gradient(137deg, #4e9eee 0%, #a8defd 100%);
        border-radius: 7px 7px 7px 7px;
        position: relative;
        .left-01-title {
          font-size: 20px;
          font-weight: bold;
          color: #fdfffe;
          line-height: 24px;
          text-shadow: 0px 2px 2px rgba(31, 51, 71, 0.4);
          margin-top: 20px;
          margin-left: 20px;
          text-align: left;
        }
        .left-01-icon {
          width: 61px;
          height: 61px;
          position: absolute;
          bottom: 7px;
          right: 20px;
          background-image: url(../assets/setting/left_01.svg);
          background-size: 100% 100%;
        }
      }
      .left-02 {
        width: 124px;
        height: 143px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        .left-02-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .left-02-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 38px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .left-02-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
      .left-03 {
        width: 177px;
        height: 143px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        text-align: left;
        .left-03-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .left-03-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 38px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .left-03-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
      .left-04 {
        width: 308px;
        height: 80px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        text-align: left;
        position: relative;

        .left-04-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .left-04-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 12px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .left-04-item-wrap {
          width: 191px;
          height: 67px;
          position: absolute;
          top: 7px;
          right: 7px;
          background-color: rgba(33, 95, 228, 0.08);
          border-radius: 10px;
          text-align: center;
          .left-04-item {
            display: inline-block;
            vertical-align: top;
            width: 31px;
            font-size: 12px;
            color: #2a4178;
            line-height: 14px;
            margin-top: 10px;
            padding-top: 34px;
          }
          .left-04-item-01 {
            background-image: url(../assets/setting/left_04_01.svg);
            background-repeat: no-repeat;
            background-size: 31px 31px;
          }
          .left-04-item-02 {
            background-image: url(../assets/setting/left_04_02.svg);
            background-repeat: no-repeat;
            background-size: 31px 31px;
          }
          .left-04-item-03 {
            background-image: url(../assets/setting/left_04_03.svg);
            background-repeat: no-repeat;
            background-size: 31px 31px;
          }
          .left-04-item-line {
            display: inline-block;
            vertical-align: top;
            width: 1px;
            height: 46px;
            margin-top: 10px;
            margin-left: 15px;
            margin-right: 15px;
            background-color: rgba(246, 249, 254, 0.8);
          }
        }
      }
    }
    .help-right-wrap {
      width: 310px;
      display: inline-block;
      vertical-align: top;
      margin-left: 7px;
      .right-01 {
        width: 308px;
        height: 101px;
        overflow: hidden;
        border-radius: 7px 7px 7px 7px;
        position: relative;
        background-image: url(../assets/setting/right_01_bg.png);
        background-size: 100% 100%;
        .right-01-title {
          font-size: 20px;
          font-weight: bold;
          color: #fdfffe;
          line-height: 24px;
          text-shadow: 0px 2px 2px rgba(31, 51, 71, 0.4);
          margin-top: 20px;
          margin-left: 20px;
          text-align: left;
        }
        .right-01-icon {
          width: 61px;
          height: 61px;
          position: absolute;
          bottom: 7px;
          right: 20px;
          background-image: url(../assets/setting/right_01.svg);
          background-size: 100% 100%;
        }
      }
      .right-02 {
        width: 97px;
        height: 99px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_02_bg.svg);
        background-size: 60px 60px;
        background-repeat: no-repeat;
        background-position: right bottom;
        .right-02-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .right-02-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
          line-height: 22px;
        }
        .right-02-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }

      .right-03 {
        width: 97px;
        height: 99px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_03_bg.svg);
        background-size: 60px 60px;
        background-repeat: no-repeat;
        background-position: right bottom;
        .right-03-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .right-03-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
          line-height: 22px;
        }
        .right-03-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }

      .right-04 {
        width: 97px;
        height: 99px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_04_bg.svg);
        background-size: 60px 60px;
        background-repeat: no-repeat;
        background-position: right bottom;
        .right-04-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .right-04-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
          line-height: 22px;
        }
        .right-04-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
      .right-05 {
        width: 177px;
        height: 125px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 7px;
        overflow: hidden;
        text-align: left;
        background-image: url(../assets/setting/right_05_bg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        .right-05-title {
          font-size: 17px;
          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 20px;
          text-shadow: 0px 2px 2px rgba(9, 12, 45, 0.25);
        }
        .right-05-icon {
          width: 61px;
          height: 61px;
          position: absolute;
          bottom: 7px;
          right: 20px;
          background-image: url(../assets/setting/right_05.svg);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .right-06 {
        width: 124px;
        height: 125px;
        border-radius: 7px;
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        background-color: #f6f9fe;
        overflow: hidden;
        text-align: left;
        .right-06-line {
          width: 20px;
          height: 3px;
          background-color: #2846ad;
          margin-left: 20px;
          margin-top: 10px;
        }
        .right-06-title {
          font-size: 17px;
          font-weight: bold;
          color: #2a4178;
          line-height: 20px;
          margin-left: 20px;
          margin-top: 14px;
          text-shadow: 0px 2px 1px rgba(35, 70, 154, 0.16);
        }
        .right-06-desc {
          font-size: 12px;
          font-weight: 400;
          margin-left: 20px;
          color: #2a4178;
          line-height: 14px;
          margin-top: 4px;
        }
      }
    }
  }
}
.about-wrap {
  width: 939px;
  height: 494px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 5px;
  background-color: #ffffff;
  background-image: url(../assets/setting/bg.png);
  background-size: 100% 100%;
  border-radius: 5px;
  box-shadow: 0px 0px 2px 0px rgba(228, 224, 201, 1);
  .about-logo {
    width: 136px;
    height: 136px;
    background-image: url(../assets/common/logo3.svg);
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 40px;
  }
  .about-name {
    font-size: 20px;
    color: #1a1a1a;
    height: 30px;
    line-height: 30px;
    font-weight: bolder;
    text-align: center;
  }
  .about-version {
    font-size: 12px;
    color: #666666;
    height: 20px;
    line-height: 20px;
    text-align: center;
    margin-top: 0px;
  }
  .about-desc {
    font-size: 14px;
    color: #666666;
    height: 20px;
    line-height: 20px;
    text-align: center;
    margin-top: 5px;
  }
  .about-nav-wrap {
    margin-top: 20px;
    text-align: center;
    .about-nav {
      display: inline-block;
      vertical-align: top;
      width: 140px;
      height: 40px;
      line-height: 40px;
      background-color: #e5edfc;
      border-radius: 20px;
      margin: 0 8px;
      color: #2f4386;
      font-size: 14px;
      font-weight: bolder;
    }
    .about-nav:hover {
      cursor: pointer;
      opacity: 0.9;
      background-color: #c9d8f5;
    }
  }

  .agreement {
    text-align: center;
    margin-top: 80px;
    color: #294075;
    font-size: 12px;
    span:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  .copyright {
    font-size: 12px;
    color: #666666;
    line-height: 20px;
    height: 20px;
    margin-top: 4px;
    text-align: center;
  }
}
.setting {
  height: 100%;

  background-color: #f5f5f5;
  position: relative;

  .device-bind-num-wrap {
    display: flex;
    align-items: center;
    margin-left: 25px;
    margin-bottom: 2px;
    svg {
      width: 17px;
      height: 17px;
    }
    img {
      margin-right: 6px;
      margin-top: -1px;
      width: 16px;
      height: 13px;
      cursor: pointer;
    }
    .device-bind-text1 {
      font-size: 14px;
      color: #1c1f28;
    }
    .device-bind-text1:hover {
      cursor: pointer;
    }
  }

  .content-wrap {
    padding-top: 0px;
    margin: 0 auto;
    height: 500px;
    margin-left: 10px;
    margin-right: 10px;
    padding: 10px;
    background-color: #ffffff;
    border-radius: 3px;
    box-sizing: border-box;

    .info-title {
      color: #1a1a1a;
      font-size: 14px;
      padding-left: 9px;
      font-weight: bolder;
      background-image: url("../assets/speed/speed_info6.png");
      background-repeat: no-repeat;
      background-size: 3px 10px;
      background-position: left center;
      height: 22px;
    }
    .line {
      margin-top: 10px;
      width: 100%;
      height: 1px;
      background-color: #f1f2f4;
    }
    .setting-text {
      margin-top: 14px;
      margin-bottom: 27px;
      width: 496px;
      color: #666666;
      font-size: 12px;
      line-height: 24px;
      text-indent: 2em;
    }
    .agreement {
      margin-left: 8px;
      margin-top: 14px;
      margin-bottom: 93px;
      color: #294075;
      font-size: 12px;
      span:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
}
</style>
